import Modal from "react-modal";
import { useParams } from 'react-router';
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ReactSortable } from "react-sortablejs";
import Button from "../../components/Button/Button";
import { SortableCategoriesItem } from "./SortableCategoriesItem";
import { onModifiersChangePosition } from "../../store/Modifiers/actions";
import { useChangeCategoriesPosition, useChangeModifierPosition } from '../../network';
import "./modal.css";

const ReorderModal = ({ visible, onClose, onSave, categories, isModifier }) => {
    const [itemState, setItemState] = useState([]);
    const { slug } = useParams();
    const { mutate: changePosition, isLoading } = useChangeCategoriesPosition({ slug });
    const { mutate: changeModifierPosition } = useChangeModifierPosition({ slug });

    const { t } = useTranslation();

    useEffect(() => setItemState(categories.data), [categories.data]);

    const onItemChange = (items) => {
        const newItems = items.map((item, i) => ({ ...item, position: i }));
        setItemState(newItems)
    };

    const onReorderCategory = () => {
        if(isModifier) {
            changeModifierPosition({ items: itemState })
        } else {
            changePosition({items: itemState});
        }

        if (!isLoading) {
            onSave();
        }
    }

    const onCancel = () => {
        setItemState(categories.data)
        onClose()
    }

    if (!itemState || (itemState && !itemState.length)) return null;

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="mt-20 mb-6 bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-4xl sm:mx-auto"
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(107, 114, 128, 0.75)',
                },
            }}
        >
            <>
                <div className="px-12 pt-12 pb-5 flex justify-between items-center">
                    <div className="font-bold text-xl">{t('Reorder Categories & Items')}</div>

                    <div>
                        <button
                            onClick={onCancel}
                            className="inline-flex justify-center mr-2 py-1.5 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                        >
                            {t('Cancel')}
                        </button>
                        <Button
                            isLoading={isLoading}
                            onClick={onReorderCategory}
                            className="inline-flex justify-center py-1.5 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                        >
                            {t('Save')}
                        </Button>
                    </div>
                </div>
                <ReactSortable
                    list={itemState}
                    setList={onItemChange}
                >
                    {itemState.map((category) => (
                        <SortableCategoriesItem
                            key={category.id}
                            category={category}
                            isModifier={isModifier}
                            delayOnTouchStart={true}
                            delay={2}
                            animation={200}
                        />
                    ))}
                </ReactSortable>
            </>
        </Modal>
    );
};

export default ReorderModal;
